import { Button } from "@/components/shadcn/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from "@/components/shadcn/dropdown-menu"
import { Icon } from "@iconify-icon/solid"
import { cn } from "@/libs/cn";
import { useApplication } from "../../context/app";

export function ModeToggle() {
  const { theme, setTheme } = useApplication()

  return (
    <DropdownMenu>
      <DropdownMenuTrigger as={innerProps => <Button variant='outline' size='icon' class='bg-white dark:bg-black me-2' {...innerProps} />}>
        <Icon icon='lucide:sun' class='rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0' />
        <Icon icon='lucide:moon' class='absolute rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100' />
        <span class='sr-only'>Toggle theme</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align='end'>
        <DropdownMenuItem onClick={() => setTheme('light')} class="flex items-center">
          <Icon icon='lucide:sun' />
          Light{' '}
          <Icon icon="lucide:check"
            size={14}
            class={cn('ml-auto', theme() !== 'light' && 'hidden')}
          />
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setTheme('dark')} class="flex items-center">
          <Icon icon='lucide:moon' />
          Dark
          <Icon icon="lucide:check"
            size={14}
            class={cn('ml-auto', theme() !== 'dark' && 'hidden')}
          />
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setTheme('system')} class="flex items-center">
          <Icon icon='lucide:laptop' />
          System
          <Icon icon="lucide:check"
            size={14}
            class={cn('ml-auto', theme() !== 'system' && 'hidden')}
          />
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
